import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from 'src/app/shared/shared.service';
import { PAGE_VIEW_TYPE } from 'src/app/utility/Constants';
import {
  debounceTime,
  distinctUntilChanged,
  startWith,
  combineLatest,
  Subscription,
  switchMap,
  tap,
  map,
} from 'rxjs';

@Component({
  selector: 'app-contractor-payment-request-list',
  templateUrl: './contractor-payment-request-list.component.html',
  styleUrls: ['./contractor-payment-request-list.component.scss'],
})
export class ContractorPaymentRequestListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = [
    'position',
    'contractorName',
    'Site',
    'conRecPaymentDate',
    'paidAmount',
    'Remark',
    'pendingBy',
    'Status',
    'Action',
  ];

  dataSource = new MatTableDataSource<any>([]);
  totalData: number = 0;
  searchControl = new FormControl('');
  isLoading :any;
  branchkey: any;
  private subscriptions = new Subscription();

  constructor(
    private _router: Router,
    public sharedservice: SharedService,
    private cdr: ChangeDetectorRef
  ) {
    this.branchkey = localStorage.getItem('branch');
  }

  ngOnInit(): void {
    this.searchControl = new FormControl('');
  }

  ngAfterViewInit() {
    Promise.resolve().then(() => {
      if (!this.paginator) {
        console.error('Paginator not initialized');
        return;
      }
      this.setupPaginationAndSearch();
    });
  }

  setupPaginationAndSearch() {
    const search$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      debounceTime(500),
      distinctUntilChanged()
    );

    const page$ = this.paginator.page.pipe(startWith({ pageIndex: 0 }));

    const combined$ = combineLatest([page$, search$]).pipe(
      tap(() => {
        // this.isLoading = true;
        this.cdr.detectChanges();
      }),
      switchMap(([pageEvent, searchText]) => {
        const pageIndex = (pageEvent as any).pageIndex ?? 0;
        return this.sharedservice.getContractorPaymentRequestPaginated({
          page: pageIndex,
          branchKey: this.branchkey,
          searchText: searchText || '',
        });
      }),
      map((res) => {
        this.totalData = res?.totalData;
        return res?.data || [];
      }),
      tap(() => {
        // this.isLoading = false;
        this.cdr.detectChanges();
      })
    );

    this.subscriptions.add(combined$.subscribe((data) => {
      this.dataSource.data = data;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  numbersFun(index: number): number {
    if (!this.paginator) return index + 1;
    return index + 1 + this.paginator.pageIndex * this.paginator.pageSize;
  }

  onView(id: any) {
    this.navigateToView(id);
  }

  onEdit(id: any) {
    this.navigateToEdit(id);
  }

  navigateToAddPage() {
    this._router.navigate([`subContractor/contractor-payment-request/add`], {
      queryParams: { viewType: PAGE_VIEW_TYPE.ADD },
    });
  }

  navigateToEdit(id: any) {
    this._router.navigate([`subContractor/contractor-payment-request/edit/${id}`], {
      queryParams: { viewType: PAGE_VIEW_TYPE.UPDATE },
    });
  }

  navigateToView(id: any) {
    this._router.navigate([`subContractor/contractor-payment-request/view/${id}`], {
      queryParams: { viewType: PAGE_VIEW_TYPE.VIEW },
    });
  }
}
